export const VOTE_SUPB= "VOTE_SUPB";
export const VOTE_SUPA= "VOTE_SUPA";
export const VOTE_SUPC= "VOTE_SUPC";
export const VOTE_SUPD= "VOTE_SUPD";
export const VOTE_TOTAL = 'VOTE_TOTAL';//总数input*/
export const ACT_ONE = 'ACT_ONE';
export const ACT_TWO = 'ACT_TWO';

export const ACT_THREE= 'ACT_THREE';
export const CHANGE_LANGUAGE= 'CHANGE_LANGUAGE';



/*配发全局变量*/
export const ClEAR_DATA= "ClEAR_DATA";






// WEBPACK FOOTER //
// ./src/store/action-types.js